<template>
    <section>
        <button
            v-if="!checkQty(item.ItemID)"
            class="cabinet-btn align-self-start"
            :class="{ 'cabinet__catalog-button': !blue }"
            @click="addToCart(item)"
        >
            <template v-if="!blue"
                >В корзину</template
            >

            <template v-else
                >Добавить в корзину</template
            >
        </button>
        <div
            v-else
            class="v2-retailer-cart__brand-product-addtocart v2-retailer-cart__brand-product-addtocart--public-home"
        >
            <div
                class="cabinet__catalog-form_minus disabled"
                @click="lessQty(item)"
            ></div>
            <span
                class="cabinet__catalog-form_input cabinet__catalog-form_input--new cabinet-form-group__input"
                >{{ checkQty(item.ItemID) }}</span
            >
            <div
                class="cabinet__catalog-form_plus"
                @click="moreQty(item.ItemID)"
            ></div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'AddingAndDeletingToPublicCart',

    props: {
        item: {
            type: Object,
            required: true,
            default: () => {}
        },
        blue: {
            type: Boolean,
            require: false,
            default: false
        }
    },

    computed: {
        ...mapGetters({
            publicCart: 'publicCart'
        })
    },

    methods: {
        ...mapActions([
            'addItemsToCardPublic',
            'quantityLessItemCartPublic',
            'quantityMoreItemCartPublic',
            'deleteItemCartPublic'
        ]),
        addToCart(item) {
            this.addItemsToCardPublic(item)

            this.$notify({
                type: 'success',
                title: 'Изделие добавлено в корзину'
            })
        },
        checkQty(id) {
            let qty = false

            this.publicCart.find(el => {
                if (el.ItemID === id) {
                    qty = el.qty
                }
            })

            return qty
        },
        lessQty(item) {
            this.publicCart.forEach(el => {
                if (el.ItemID === item.ItemID) {
                    if (el.qty > 1) {
                        this.quantityLessItemCartPublic(item.ItemID)
                    } else {
                        this.deleteItem(item.ItemID)
                    }
                }
            })
        },
        moreQty(id) {
            this.quantityMoreItemCartPublic(id)
        },
        deleteItem(id) {
            this.deleteItemCartPublic(id)

            this.$notify({
                type: 'default',
                title: 'Изделие удалено из корзины'
            })
        }
    }
}
</script>
